import React from "react";
import { Helmet } from "react-helmet";
import Breadcrumb from "../common/breadcrumb";
import {
  makeStyles,
  Typography,
  Container,
  Box,
  Grid,
  Button,
} from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    padding: theme.spacing(2),
    backgroundColor: theme.palette.white,
    position: "relative",
    [theme.breakpoints.down("sm")]: {
      marginTop: "100px",
    },
    fontFamily: "Times New Roman",
    fontSize: "12px",
  },
  title: {
    fontSize: "40px",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
  },
  eklogo: {
    width: "350px",
    height: "100px",
    marginInline: "auto",
  },
  buttonContainer: {
    display: "flex",
    justifyContent: "center",
    gap: "20px",
    marginTop: "20px",
  },
}));

const dacRules = () => {
  const classes = useStyles();
  return (
    <div>
      <Helmet>
        <title>eksplode | Official DAC Rules</title>
      </Helmet>
      <Breadcrumb title={"DAC Rules"} />
      <section className="about-page section-b-space">
        <div className="container">
          <div className="row">
            <div className="col-sm-12">
              <Grid style={{ minHeight: "100vh" }} container>
                <div id="dacrules" className={classes.root}>
                  <Container maxWidth="md">
                    <Box mb={2} className={classes.title}>
                      <img
                        className={classes.eklogo}
                        src="/assets/images/icon/logo-eksplode.png"
                        alt="eksplode!"
                      />
                    </Box>
                    <div style={{ textAlign: "center" }}>
                      <br />
                      <strong
                        style={{
                          color: "black",
                          fontSize: "12px",
                          fontFamily: "Times New Roman",
                        }}
                      >
                        DIGITAL AD CARD (DAC) PROGRAM
                      </strong>
                      <br />
                      <br />
                      <strong
                        style={{
                          color: "black",
                          fontSize: "12px",
                          fontFamily: "Times New Roman",
                        }}
                      >
                        OFFICIAL RULES
                      </strong>
                      <br />
                      <br />
                    </div>
                    <Typography
                      variant="body1"
                      style={{
                        fontFamily: "Times New Roman",
                        fontSize: "12px",
                        lineHeight: "1.5em",
                        color: "black",
                      }}
                    >
                      <strong>Effective Date:</strong> 01/01/2025
                      <br />
                      <br />
                      <strong>1. Overview:</strong>
                      <br />
                      The Digital Ad Card (DAC) program is an interactive
                      platform offered by eksplode! Interactive, a Continent 5
                      Media Group, Inc. (C5M) division. The DAC program is a
                      cutting-edge platform allowing Members to create and share
                      customized digital advertisements (“DACs”) using products
                      from participating retailers’ catalogs. Members can send
                      DACs to their contacts via email or text, giving
                      recipients direct hyperlinks to purchase the promoted
                      products. By participating in the DAC program, users agree
                      to abide by these rules.
                      <br />
                      C5M takes a privacy-first approach, ensuring no cookies or
                      intrusive tracking methods are used in the DAC Program.
                      This commitment allows users to enjoy a secure and
                      seamless experience without concerns about data
                      collection.
                      <br />
                      <br />
                      <strong>2. Eligibility:</strong>
                      <br />
                      The DAC Program is open to:
                      <ul>
                        <li>
                          {"\u00A0"}
                          {"\u00A0"}
                          {"\u00A0"}
                          {"\u00A0"}
                          {"\u00A0"}• Individuals 18 years of age or older, or
                          those aged 13 to 17 with verifiable parental or legal
                          guardian consent, where participation is not
                          prohibited by law.
                        </li>
                        <li>
                          {"\u00A0"}
                          {"\u00A0"}
                          {"\u00A0"}
                          {"\u00A0"}
                          {"\u00A0"}• Participants who meet all requirements
                          outlined in these rules.
                        </li>
                      </ul>
                      <br />
                      <strong>3. How the DAC Program Works:</strong>
                      <ol>
                        <li>
                          <strong>1. Sign-Up:</strong> Participants register to
                          become eksplode! Members at eksplode.com.
                        </li>
                        <li>
                          <strong>2. eksplode! Code:</strong> Upon registration,
                          each Member is assigned a unique QR Code (called an
                          eksplode! Code) for tracking their activity and sales.
                        </li>
                        <li>
                          <strong>3. Dashboard Access:</strong> Members log into
                          their eksplode! account to access their dashboard.
                        </li>
                        <li>
                          <strong>4. Retailers Catalog:</strong> From their
                          dashboard, Members activate the ‘Retailers Catalog’
                          tab to browse available products and services.
                        </li>
                        <li>
                          <strong>5. Promotional Rewards:</strong> Each product
                          or service displays a reward value (e.g., a dollar
                          amount or percentage of the sale) offered by the
                          retailer.
                        </li>
                        <li>
                          <strong>6. Selection and Customization:</strong>{" "}
                          Members select a product or service to promote and
                          choose a greeting (or customize their own).
                        </li>
                        <li>
                          <strong>7. Contact List Activation:</strong> Members
                          activate their ‘Contact List’ and select recipients
                          from their uploaded contacts.
                        </li>
                        <li>
                          <strong>8. Sending DACs:</strong> After choosing
                          recipients, Members click the ‘Send’ tab to deliver
                          the DAC via email or text message.
                        </li>
                        <li>
                          <strong>9. Encrypted Tracking:</strong> Each DAC is
                          automatically encrypted with the Member’s eksplode!
                          Code, allowing C5M’s system to track purchases made
                          through the shared DAC.
                        </li>
                        <li>
                          <strong>10. Earning Rewards:</strong> If a recipient
                          makes a purchase, the reward value displayed in the
                          retailer’s catalog is credited to the Member’s
                          account.
                        </li>
                      </ol>
                      {/* <br /> */}
                      <strong>4. Data Privacy and Contact List Usage:</strong>
                      <ol>
                        <li>
                          <strong>1. No Cookies, No Tracking:</strong>
                          <br />
                          <li>
                            {"\u00A0"}
                            {"\u00A0"}
                            {"\u00A0"}
                            {"\u00A0"}
                            {"\u00A0"}o The DAC Program operates without the use
                            of cookies or intrusive tracking technologies,
                            ensuring user privacy and trust.
                          </li>
                          <li>
                            {"\u00A0"}
                            {"\u00A0"}
                            {"\u00A0"}
                            {"\u00A0"}
                            {"\u00A0"}o C5M emphasizes ethical innovation,
                            allowing participants to engage without compromising
                            their personal data.
                          </li>
                        </li>
                        <li>
                          <strong>2. Limited Data Collection:</strong>
                          <br />
                          <li>
                            {"\u00A0"}
                            {"\u00A0"}
                            {"\u00A0"}
                            {"\u00A0"}
                            {"\u00A0"}o C5M does not collect, store, or
                            distribute participants’ contact lists uploaded for
                            use on their dashboard.
                          </li>
                          <li>
                            {"\u00A0"}
                            {"\u00A0"}
                            {"\u00A0"}
                            {"\u00A0"}
                            {"\u00A0"}o Uploaded contact data is for the
                            participant’s personal use only and exists solely
                            within their session for convenience.
                          </li>
                        </li>
                        <li>
                          <strong>3. Participant Responsibility:</strong>
                          <br />
                          <li>
                            {"\u00A0"}
                            {"\u00A0"}
                            {"\u00A0"}
                            {"\u00A0"}
                            {"\u00A0"}o Participants are responsible for
                            ensuring they have the consent of their contacts
                            before sending DACs.
                          </li>
                          <li>
                            {"\u00A0"}
                            {"\u00A0"}
                            {"\u00A0"}
                            {"\u00A0"}
                            {"\u00A0"}o Any misuse of contact data for spam or
                            unsolicited messaging is strictly prohibited.
                          </li>
                        </li>
                      </ol>
                      <strong>5. Payment and Rewards:</strong>
                      <ol>
                        <li>
                          <strong>1. Reward Distribution:</strong>
                          <br />
                          <li>
                            {"\u00A0"}
                            {"\u00A0"}
                            {"\u00A0"}
                            {"\u00A0"}
                            {"\u00A0"}o Each product or service in the
                            retailer’s catalog specifies a reward value (e.g., a
                            dollar amount or percentage of the purchase price).
                          </li>
                          <li>
                            {"\u00A0"}
                            {"\u00A0"}
                            {"\u00A0"}
                            {"\u00A0"}
                            {"\u00A0"}o When a DAC recipient makes a purchase,
                            the reward value specified by the retailer is
                            credited to the account provided by the Member.
                          </li>
                          <li>
                            {"\u00A0"}
                            {"\u00A0"}
                            {"\u00A0"}
                            {"\u00A0"}
                            {"\u00A0"}o Members do not earn a percentage of the
                            sale proceeds beyond the reward value specified in
                            the retailer’s catalog.
                          </li>
                        </li>
                        <li>
                          <strong>2. Payment Processing:</strong>
                          <br />
                          <li>
                            {"\u00A0"}
                            {"\u00A0"}
                            {"\u00A0"}
                            {"\u00A0"}
                            {"\u00A0"}o Payments are deposited into the account
                            selected by the Member.
                          </li>
                          <br />
                          <li>
                            {"\u00A0"}
                            {"\u00A0"}
                            {"\u00A0"}
                            {"\u00A0"}
                            {"\u00A0"}o Deposits are typically made within 24
                            hours of the purchase being verified.
                          </li>
                          <br />
                          <li>
                            {"\u00A0"}
                            {"\u00A0"}
                            {"\u00A0"}
                            {"\u00A0"}
                            {"\u00A0"}o Parents may manage minors’ earnings
                            through C5M’s eMoney Network.
                          </li>
                        </li>
                      </ol>
                      <strong>6. Prohibited Activities:</strong>
                      <br />
                      Participants must not:
                      <ul>
                        <li>
                          {"\u00A0"}
                          {"\u00A0"}
                          {"\u00A0"}
                          {"\u00A0"}
                          {"\u00A0"}• Use bots, automated tools, or deceptive
                          practices to generate activity.
                        </li>
                        <br />
                        <li>
                          {"\u00A0"}
                          {"\u00A0"}
                          {"\u00A0"}
                          {"\u00A0"}
                          {"\u00A0"}• Share DACs without the consent of
                          recipients.
                        </li>
                        <br />
                        <li>
                          {"\u00A0"}
                          {"\u00A0"}
                          {"\u00A0"}
                          {"\u00A0"}
                          {"\u00A0"}• Alter or misrepresent DAC content.
                        </li>
                      </ul>
                      <br />
                      <strong>7. Intellectual Property Rights:</strong>
                      <br />
                      All DAC content and associated materials are the
                      intellectual property of C5M or its advertisers.
                      Participants are granted a limited license to use DAC
                      content solely for program purposes. Unauthorized use is
                      prohibited.
                      <br />
                      <br />
                      <strong>8. General Rules and Disputes:</strong>
                      <ul>
                        <li>
                          {"\u00A0"}
                          {"\u00A0"}
                          {"\u00A0"}
                          {"\u00A0"}
                          {"\u00A0"}• Participants must comply with all
                          applicable laws and platform policies.
                        </li>
                        <br />
                        <li>
                          {"\u00A0"}
                          {"\u00A0"}
                          {"\u00A0"}
                          {"\u00A0"}
                          {"\u00A0"}• Disputes will be resolved through binding
                          arbitration in Las Vegas, Nevada, per the Federal
                          Arbitration Act.
                        </li>
                        <br />
                      </ul>
                      <br />
                      <strong>9. Contact Information:</strong>
                      <br />
                      For any questions or assistance, please email{" "}
                      <a href="mailto:Admin@C5M.World">Admin@C5M.World</a>.
                      <br />
                      By participating in the DAC Program, users acknowledge
                      that they have read, understood, and agree to these
                      updated rules.
                    </Typography>
                  </Container>
                </div>
              </Grid>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default dacRules;
